import {GridColDef} from '@mui/x-data-grid'

const addedPatientColumns: GridColDef[] = [
  {field: 'firstName', headerName: 'First name', flex: 1},
  {field: 'lastName', headerName: 'Last name', flex: 1},
  {field: 'physicianName', headerName: 'Physician name', flex: 1},
  {field: 'birthdate', headerName: 'Date of birth', flex: 1},
]

export default addedPatientColumns
